/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Faq_How_AInputs */



/**
* | output |
* | --- |
* | "Each customer is billed in monthly periods. A period starts on the day the customer goes live — the day it is created, or a contract customer's start date — ..." |
*
* @param {Partner_Faq_How_AInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_how_a = /** @type {((inputs?: Partner_Faq_How_AInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_How_AInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jeder Kunde wird in monatlichen Zeiträumen abgerechnet. Ein Zeitraum beginnt an dem Tag, an dem der Kunde startet — dem Tag, an dem er angelegt wurde, bei Vertragskunden dem Vertragsbeginn — und endet am selben Tag des Folgemonats (bzw. am letzten Tag eines kürzeren Monats). Endet ein Zeitraum, berechnet oneAI die Abrechnung dafür: die Plätze, eventuelle Zusatzpakete und die KI-Nutzung über dem enthaltenen Guthaben.")
	return /** @type {LocalizedString} */ ("Each customer is billed in monthly periods. A period starts on the day the customer goes live — the day it is created, or a contract customer's start date — and ends on the same day of the next month (or on that month's last day, if it is shorter). When a period ends, oneAI calculates the bill for it: the seats, any add-ons, and AI usage above the included credit.")
});